import React from "react";
import { persistStore, persistReducer } from "redux-persist";
import { createStore, applyMiddleware, compose } from "redux";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import storage from "redux-persist/lib/storage";
import createRootReducer from "./reducers";
import ReduxThunk from "redux-thunk";

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: [],
};

const persistedReducer = persistReducer(persistConfig, createRootReducer());
const middlewares = [ReduxThunk];

const Store = ({ element }) => {
  const store = createStore(
    persistedReducer,
    compose(applyMiddleware(...middlewares))
  );
  const persistor = persistStore(store);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {element}
      </PersistGate>
    </Provider>
  );
};

export default Store;
